import { createFlightResultsIntegration } from '../funnels/FlightResults/integration';
export const createIntegration = ({
  storageClient
}) => {
  const Odigeo = window.Odigeo;
  const metaURL = Odigeo.Settings.getProperty('serviceUrlFormatter')('meta/createshoppingcart');
  return {
    flightResults: createFlightResultsIntegration(storageClient, {
      trigger: (...args) => Odigeo.trigger(...args),
      AB: Odigeo.AB,
      fetcher: Odigeo.SessionScope.fetcher,
      metaURL,
      setSessionStorageKey: (key, value) => Odigeo.Session.set(key, value),
      getMapiLandingPage: () => Odigeo.Utils.findLandingPageType(Odigeo.Utils.decodeParams(window.location.search.substring(1)).landingPageType)
    }, window.fetch)
    // TODO: add more integrations here
  };
};